exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-4e08ca5e]{margin-top:20px}.person-photo[data-v-4e08ca5e]{width:150px;height:150px;overflow:hidden;border-radius:150px}.person-photo img[data-v-4e08ca5e]{width:152px;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e08ca5e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/info/People.vue
// module id = 219
// module chunks = 0